import {CommonDetail} from '../../../CommonDetail/CommonDetail';
import {ThreeUnit} from '../../ThreeUnit/ThreeUnit';
import {KitchenService} from '../../../../services/KitchenService/KitchenService';
import {ISaveUnitDetailData} from '../../../../../../common-code/interfaces/saveData/ISaveUnitDetailData';
import {Box3, Object3D} from "three";
import {ThreeMathHelper} from "../../../../helpers/ThreeMathHelper/ThreeMathHelper";

export class ThreeUnitDetail extends CommonDetail {
    saveData: ISaveUnitDetailData;
    service: KitchenService;
    unit: ThreeUnit;
    dummyBox: Box3;

    constructor(options: ISaveUnitDetailData, unit: ThreeUnit) {
        super(options, unit);
        this.service = unit.service;
        this.unit = unit;
        this.saveData = this.initThreeUnitSaveData(options);
        this.dummyBox = new Box3();
    }

    public getChildById(childId: number): ThreeUnitDetail | undefined {
        return undefined;
    }

    public getLocalCoverBox(mesh: Object3D): Box3 {
        this.dummyBox.makeEmpty().setFromObject(mesh);
        if (!ThreeMathHelper.isFiniteBox3(this.dummyBox)) {
            throw new Error('error-ThreeUnitDetail-getDummyBox');
        }
        this.dummyBox.min = this.unit.view3d.worldToLocal(this.dummyBox.min);
        this.dummyBox.max = this.unit.view3d.worldToLocal(this.dummyBox.max);

        return this.dummyBox;
    }

    protected initThreeUnitSaveData(options: ISaveUnitDetailData): ISaveUnitDetailData {
        if (options.isVisible === undefined) {
            options.isVisible = true;
        }
        return options;
    }

    public getData(): ISaveUnitDetailData {
        let data: ISaveUnitDetailData = super.getData();
        delete data.isStick;
        delete data.isLevelStick;
        delete data.isWallStick;
        return data;
    }

    public hide() {
        this.setVisible(false);
    }

    public show() {
        this.setVisible(true);
    }

    public isVisible(): boolean {
        return !!this.saveData.isVisible;
    }

    public isSelfVisible(): boolean {
        return !!this.saveData.isSelfVisible;
    }

    public setVisible(isVisible: boolean) {
        if (this.saveData.isSelfVisible !== undefined) {
            this.saveData.isVisible = this.saveData.isSelfVisible;
        } else {
            this.saveData.isVisible = isVisible;
        }
        this.updateView3dVisible();
    }

    public setSelfVisible(isVisible: boolean) {
        this.saveData.isSelfVisible = isVisible;
        this.saveData.isVisible = isVisible;
        this.updateView3dVisible();
    }

    public clearSelfVisible() {
        this.saveData.isSelfVisible = undefined;
    }

    protected updateView3dVisible() {
        this.view3d.visible = !!this.saveData.isVisible;
    }
}